// src/api/paginateAmplify.ts
import { ApiError } from './ApiClient';
import { AmplifyFilter, matchesAmplifyFilter } from '@utils/Api';

export type ListResult<T> = { data: T[]; nextToken?: string | null };

type ApiFetch = {
    data: any,
    errors: any,
    nextToken: string
}

export async function fetchAllByOwner<T = any>(
    fetchFunction: (nextToken?: string) => Promise<ApiFetch>,
    modelName: string,
    amplifyClientFilter?: AmplifyFilter,
): Promise<T[]> {
    const out: T[] = [];
    let nextToken: string | undefined;

    while (true) {
        const { data, errors, nextToken: apiNextToken } = await fetchFunction(nextToken)
        if (errors) {
            throw new ApiError(`Errores al crear ${String(modelName)}`, "API_ERROR", errors);
        }

        const filteredData = (data || []).filter((item: T) => matchesAmplifyFilter(item, amplifyClientFilter));

        if (filteredData) out.push(...filteredData);
        nextToken = apiNextToken ?? undefined;
        if (!nextToken) break;
    }
    return out;
}